import TradeIn from './TradeIn';

export default TradeIn;
